import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cummins-software-electronics',
  templateUrl: './cummins-software-electronics.component.html',
  styleUrls: ['./cummins-software-electronics.component.scss']
})
export class CumminsSoftwareElectronicsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
